import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { SurveyForm } from "~/components/specifics/vendors/settings/surveys/form/SurveyForm";
import { PATH as SETTING } from "~/pages/vendors/settings";
import { PATH as INDEX } from "~/pages/vendors/settings/surveys/index";
import SettingStyles from "../../SettingStyle.module.scss";

export function Page() {
	return (
		<VendorLayoutV2>
			<VendorSettingLayout>
				<div className={SettingStyles.PcBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: INDEX, label: "アンケート設定" },
							{ label: "新規作成" }
						]}
					/>
				</div>
				<div className={SettingStyles.SpBreadcrumbsWrapper}>
					<Breadcrumbs
						items={[
							{ as: Link, href: SETTING, label: "設定一覧" },
							{ as: Link, href: INDEX, label: "アンケート設定" },
							{ label: "新規作成" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader title="アンケート設定" />
					<PanelBody>
						<SurveyForm />
					</PanelBody>
				</Panel>
			</VendorSettingLayout>
		</VendorLayoutV2>
	);
}
